<template>
  <el-menu :default-active="mod" router>
    <el-menu-item index="yxzt" route="/service/yxzt">
      <div class="active"></div>营销主题
    </el-menu-item>
    <el-menu-item index="fwxs" route="/service/fwxs">
      <div class="active"></div>24节气
    </el-menu-item>
  </el-menu>
</template>

<script>
export default {
  name: "commodity-marketing-aside",
  props: ["mod"]
};
</script>

<style lang="less">
li.el-menu-item .active {
  display: inline-block;
  width: 4px;
  height: 30px;
}
li.is-active > .active {
  display: inline-block;
  width: 4px;
  height: 30px;
  background: rgba(27, 153, 79, 1);
  border-radius: 0px 5px 5px 0px;

  position: relative;

  left: -10px;
}
</style>
